import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ErrorDialogComponent } from '@UIparts/common/error-dialog/mobile-ver/error-dialog.component';
import { ErrorDialogData } from '@VineyardLib/data/error-dialog-data';
import { ErrorDialogWrapperService } from '@VineyardLib/services/error-dialog-wrapper.service';
import { DISABLE_ZOOM_STYLE_CLASS } from '@VineyardLibConstant/constant';

/**
 *  エラーダイアログ用サービス
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorDialogService implements ErrorDialogWrapperService {
  private dialog = inject(MatDialog);

  /**
   * ダイアログを開いているか
   */
  private isDialogOpen = false;

  /**
   * ダイアログを表示する。
   * @param data 表示データ
   */
  openErrorDialog(data: ErrorDialogData): void {
    if (this.isDialogOpen) {
      return;
    }
    this.isDialogOpen = true;
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '80%',
      data: {
        message: data.message,
        timestamp: data.timestamp,
      },
    });
    document.body.classList.add(DISABLE_ZOOM_STYLE_CLASS);

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
      if (this.dialog.openDialogs.length === 0) {
        document.body.classList.remove(DISABLE_ZOOM_STYLE_CLASS);
      }
    });
  }
}
